module.exports = __webpack_public_path__ + "static/media/paleo-min.1218ada5.png";